/* global axios */
import ApiClient from './ApiClient';

class ProactiveChatApi extends ApiClient {
  constructor() {
    super('proactive_chat_invitations', { accountScoped: true });
  }

  getOnlineContacts() {
    return axios.get(`${this.url}/online_contacts`);
  }

  sendInvitation({ contactInboxId, message }) {
    return axios.post(this.url, {
      contact_inbox_id: contactInboxId,
      message,
    });
  }

  inviteAll({ message } = {}) {
    return axios.post(`${this.url}/invite_all`, { message });
  }

  sendGreeting({ contactInboxId }) {
    return axios.post(`${this.url}/send_greeting`, {
      contact_inbox_id: contactInboxId,
    });
  }

  getAutoGreetingStatus() {
    return axios.get(`${this.url}/auto_greeting_status`);
  }

  toggleAutoGreeting(enabled) {
    return axios.post(`${this.url}/toggle_auto_greeting`, { enabled });
  }
}

export default new ProactiveChatApi();
